import React from 'react';
import MonthlyExpenseComparison from './MonthlyExpenseComparison';
import './ExpenseMovementWatch.css';

const ExpenseMovementWatch = () => <MonthlyExpenseComparison movementOnly />;

export default ExpenseMovementWatch;
